import {Injectable} from "@angular/core";
import {EventBus} from "../../event/EventBus";
import {MessageEventData} from "../../event/ActivityEvent";
import {Scilearn} from "../../constants";
import {ActivityModalEvent, ACTIVITY_STATUS, ActivityEventData} from "../../event/ActivityEvent";

@Injectable()
export class ModalConfig {

    private currentModal: string;
    private currentMessage: string;

    constructor(private eventBus: EventBus) {
    }

    private triggerRaEvent(status: ACTIVITY_STATUS, data: any = {}): void {
        this.eventBus.next(new ActivityModalEvent(status, data));
    }

    public getCurrentModal(): string {
        return this.currentModal;
    }

    public removeAllModals(): void {
        this.currentModal = "";
        this.currentMessage = "";
        this.triggerRaEvent(ACTIVITY_STATUS.modal_close, new ActivityEventData({type: "all"}));
    }

    public removeModal(data: ActivityEventData = undefined): void {
        this.currentModal = "";
        this.currentMessage = "";
        this.triggerRaEvent(ACTIVITY_STATUS.modal_close, data);
    }

    public openModal(data: ActivityEventData = undefined): void {
        this.currentModal = data.type;
        this.triggerRaEvent(ACTIVITY_STATUS.modal_open, data);
    }

    public openMessageModal(message: string): void {
        if (this.currentMessage !== message) {
            this.currentMessage = message;
            this.openModal(new MessageEventData({
                type: Scilearn.MESSAGE_MODAL, message: message
            }));
        }
    }


}